import { Button, Group, Radio, Stack } from "@mantine/core";
import { useState } from "react";
import CreatableContactListSelector from "../../../../../../components/Selectors/CreatableContactListSelector";
import { useLanguage } from "../../../../../../stores/LanguageStore";
import { IconCopy } from "@tabler/icons-react";
import { notifications } from "@mantine/notifications";
import { useParams } from "react-router-dom";
import { deselectAll } from "../../../../leadsTracking/utils";
import { transformFilterToServer } from "../../../../../../functions/utilFunctions";
import { importContactlistFromStepStat } from "../../../../../../api/StatsAPI";

const StatsContactsCopyListDestination = ({
  copyType,
  handleClose,
  onFinish,
  tableFilter,
  tableSelection,
}) => {
  const lang = useLanguage((s) => s.language);
  const { campaign, workflow, stepId, type } = useParams();

  const [value, setValue] = useState("list");
  const [list, setList] = useState(null);

  const selectedIds = tableSelection;
  const filter = transformFilterToServer(tableFilter);

  const [loading, setLoading] = useState(false);

  const handleValueChange = (change) => {
    setValue(change);
    setTimeout(() => {
      document.getElementById(`${change}-selector`);
    }, 50);
  };

  const main = () => {
    setLoading(true);
    importContactlistFromStepStat({
      contact_type: type,
      step_id: stepId,
      workflow_id: workflow,
      workflow_programmation_id: campaign,
      contact_list_id: list?.id,
      contacts_selection: {
        contact_ids: copyType === "selection_inverse" ? [] : selectedIds || [],
        excluded_contact_ids:
          copyType === "selection_inverse" ? selectedIds : [],
        filter: copyType === "filter" ? filter : { mode: "or", values: [] },
      },
    })
      .then((res) => {
        onFinish?.(copyType);
        notifications.show({
          message: lang.contact_lists.content.copy_selection.success,
          color: "tertiary.8",
        });
        handleClose();

        if (copyType === "selection") {
          deselectAll();
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Stack w={300}>
      <Radio.Group value={value} onChange={handleValueChange} name="value">
        <Stack gap={4} mt={"sm"}>
          <CreatableContactListSelector
            setValue={setList}
            value={list}
            disabled={value !== "list"}
            id={"list-selector"}
            autoFocus={true}
          />
        </Stack>
      </Radio.Group>
      <Group justify="end">
        <Button
          leftSection={<IconCopy size={16} />}
          onClick={main}
          loading={loading}
          disabled={!list}
        >
          {lang.contact_lists.copy_to_user.dialog.submit_button}
        </Button>
      </Group>
    </Stack>
  );
};

export default StatsContactsCopyListDestination;
